import { render, staticRenderFns } from "./Contador.vue?vue&type=template&id=670efbf6&"
import script from "./Contador.vue?vue&type=script&lang=js&"
export * from "./Contador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports